import { env } from '@/config/env';

const UNKNOWN_COMMIT = 'unknown';

/**
 * The git commit this bundle was built from, so the operator can match the
 * front end to the API's `GET /api/v1/health` commit. The image build
 * (`deploy/deploy.sh`) stamps `BUN_PUBLIC_BUILD_COMMIT`; a laptop build reports
 * `unknown`. Read through `config/env`.
 */
export const getBuildCommit = (): string => env.buildCommit || UNKNOWN_COMMIT;
